import React from "react";
import MacbookPage from "./BlackjackDesktopPage.js";
import IphonePage from "./BlackjackPhonePage.js";
import styled from "styled-components";

const BlackjackPage = () => {
  return (
    <ResponsiveContainer>
      <div className="desktop-view">
        <MacbookPage />
      </div>
      <div className="mobile-view">
        <IphonePage />
      </div>
    </ResponsiveContainer>
  );
};

const ResponsiveContainer = styled.div`
  width: 100%;
  margin: auto;

  .desktop-view {
    display: block;
  }

  .mobile-view {
    display: none;
  }

  @media (max-width: 1720px) {
    .desktop-view {
      display: none;
    }

    .mobile-view {
      display: block;
    }
  }
`;

export default BlackjackPage;
